import { createTheme, Theme } from '@mui/material/styles';

import LightTheme from './LightTheme';

export const TEXT_VARIANTS = {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.38)',
    hint: 'rgba(0, 0, 0, 0.38)',
    error: 'rgba(235, 20, 20, 1)'
};

export const SUCCESS_COLOR = {
    main: '#008A15',
    dark: '#3B873E',
    light: '#7BC67E',
    textDark: '#4CAF50',
    lightBg: '#4CAF50',
    border: '#4CAF5080'
};

const MaterialTheme = (plugin: typeof LightTheme): Theme =>
    createTheme({
        palette: {
            common: {
                black: plugin.colors.black
            },
            primary: {
                main: plugin.colors.primary.main,
                dark: plugin.colors.primary.dark,
                light: plugin.colors.primary.light
            },
            secondary: {
                main: plugin.colors.secondary.main
            },
            error: {
                main: plugin.colors.error
            },
            warning: {
                main: plugin.colors.warning
            },
            info: {
                main: plugin.colors.info
            },
            success: {
                main: plugin.colors.success
            },
            background: {
                default: plugin.colors.background
            },
            text: {
                primary: plugin.colors.text.main,
                secondary: plugin.colors.text.secondary,
                disabled: plugin.colors.text.disabled
            },
            actions: {
                main: plugin.colors.actions.main,
                background: plugin.colors.actions.background,
                disabledBackground: plugin.colors.actions.disabledBackground,
                disabledText: plugin.colors.actions.disabledText
            },
            other: {
                stroke: plugin.colors.other.stroke,
                divider: plugin.colors.other.divider,
                backdrop: plugin.colors.other.backdrop,
                snackbar: plugin.colors.other.snackbar,
                outline: plugin.colors.other.outline,
                brandColor: plugin.colors.other.brandColor
            }
        },
        typography: {
            fontFamily: plugin.fonts.fontFamily,
            h1: {
                fontSize: '24px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '32px',
                letterSpacing: '0.15px',
                textAlign: 'left'
            },
            body1: {
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '24px',
                letterSpacing: '0.15px',
                textAlign: 'left'
            },
            body2: {
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '20px',
                letterSpacing: '0.15px',
                textAlign: 'left'
            }
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none'
                    },
                    containedSecondary: {
                        backgroundColor: plugin.colors.secondary.lightBackground,
                        color: plugin.colors.primary.main,
                        '&:hover': {
                            backgroundColor: plugin.colors.secondary.hoverBackground,
                            color: plugin.colors.primary.dark
                        }
                    },
                    containedPrimary: {
                        backgroundColor: plugin.colors.primary.main,
                        color: plugin.colors.primary.light,
                        '&:disabled': {
                            backgroundColor: plugin.colors.primary.main,
                            color: plugin.colors.primary.light,
                            opacity: 0.5
                        }
                    }
                }
            },
            MuiCheckbox: {
                styleOverrides: {
                    colorSecondary: {
                        '&$checked': {
                            color: plugin.colors.primary.main
                        }
                    }
                }
            },
            MuiFab: {
                styleOverrides: {
                    secondary: {
                        backgroundColor: plugin.colors.secondary.lightBackground,
                        color: plugin.colors.primary.main,
                        '&:hover': {
                            backgroundColor: plugin.colors.secondary.hoverBackground,
                            color: plugin.colors.primary.dark
                        }
                    }
                }
            },
            MuiRadio: {
                styleOverrides: {
                    colorSecondary: {
                        '&$checked': {
                            color: plugin.colors.primary.main
                        }
                    }
                }
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        textTransform: 'none'
                    }
                }
            }
        }
    });

export default MaterialTheme;
